import type { PopupData } from 'webapp-types';

import DataPerformanceSummaryComponent from 'webapp/components/data-performance/summary/index';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class DataPerformancePopupDataPerformanceSummaryComponent extends PopupInnerContextComponent<PopupData.Common.DataPerformanceSummary> {
	<template>
		<span class="gradient gradient--1"></span>
		<span class="gradient gradient--2"></span>
		<span class="gradient gradient--3"></span>
		<DataPerformanceSummaryComponent
			@model={{this.popupData.model}}
			@hideGenieInput={{this.popupData.hideGenieInput}}
			@closeFn={{this.close}}
			@onContentChange={{this.reposition}}
		/>
	</template>
}
